import {
  groupBy,
  isEmpty,
  prop,
  symmetricDifference
} from 'ramda';

export const groupByProp = <T extends {}>(propName: string) => groupBy<T>(prop(propName));

export const lastIndex = (arr: any[]) => arr.length - 1;

export const equalValues = (listA: string[] | number[], listB: string[] | number[]) => isEmpty(symmetricDifference<string | number>(listA, listB));

/** Splits items, in order, into batches whose sizes sum to at most maxSize; an item larger than maxSize gets a batch of its own. */
export const batchBySize = <T>(items: T[], sizeOf: (item: T) => number, maxSize: number): T[][] => items
  .reduce<{ batches: T[][]; lastSize: number }>(({ batches, lastSize }, item) => {
    const size = sizeOf(item);
    const last = batches[batches.length - 1];
    return last && lastSize + size <= maxSize
      ? { batches: [...batches.slice(0, -1), [...last, item]], lastSize: lastSize + size }
      : { batches: [...batches, [item]], lastSize: size };
  }, { batches: [], lastSize: 0 })
  .batches;
